<mat-form-field appearance="outline" class="dialog">
	@if (control?.invalid && control?.touched) {
		<mat-error>
			{{ errorKey | translate }}
		</mat-error>
	}
	<mat-label class="mat-body-1">
		{{ labelKey | translate }}
	</mat-label>

	@if (hasIncidentCodeOptions) {
		<mat-select [formControl]="control" (selectionChange)="selectionChange.emit($event.value)" panelClass="incident-code-panel" (openedChange)="onOpenedChange($event)">
			<div class="incident-code-filter-container">
				<input #incidentCodeFilterInput class="incident-code-filter-input" [placeholder]="'mes.mes-production-terminal.incident-code-select.filter-placeholder' | translate" [formControl]="filterControl" (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
			</div>
			@for (group of filteredIncidentCodesByGroup; track group.group) {
				<mat-optgroup [label]="group.group">
					@for (incidentCode of group.codes; track incidentCode.id) {
						<mat-option [value]="incidentCode">({{ incidentCode.alias }}) {{ incidentCode.name }}</mat-option>
					}
				</mat-optgroup>
			}
		</mat-select>
	} @else {
		<input matInput class="incident-code-missing-setup" [value]="'mes.mes-production-terminal.incident-code-select.missing-setup' | translate" disabled readonly />
	}
</mat-form-field>
